export const WEBGL_MAX_TEXTURE_DIMENSION = 16384;
export const RECOMMENDED_MAX_TEXTURE_DIMENSION = 8192;

export const referenceImageMaxDimension = (width: number, height: number): number =>
  Math.max(width, height);

export const referenceImageExceedsRecommendedSize = (
  width: number,
  height: number,
): boolean => referenceImageMaxDimension(width, height) > RECOMMENDED_MAX_TEXTURE_DIMENSION;

export const referenceImageDownscaleDismissKey = (
  projectId: number,
  imageUrl: string,
): string => `referenceImageDownscaleDismissed:${projectId}:${imageUrl}`;

export const isReferenceImageDownscaleDismissed = (
  projectId: number,
  imageUrl: string,
): boolean => {
  try {
    return sessionStorage.getItem(referenceImageDownscaleDismissKey(projectId, imageUrl)) === '1';
  } catch {
    return false;
  }
};

export const dismissReferenceImageDownscalePrompt = (
  projectId: number,
  imageUrl: string,
): void => {
  try {
    sessionStorage.setItem(referenceImageDownscaleDismissKey(projectId, imageUrl), '1');
  } catch {
    // Ignore storage failures in private browsing or restricted contexts.
  }
};
